import React from 'react';
import { Route, Switch } from 'react-router';
import { adminMenuRoutes } from '../constants';

export const AdminMenuRoutes = () => {

  return (
		<Switch>
			{
				adminMenuRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />						
					)
				})
			}
		</Switch>
	);
}